export default "__VITE_ASSET__Bbb$0cwY__"